export default {
  "general": {
    "loading_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement en cours"])},
    "refresh_page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rafraîchir la page"])}
  },
  "error": {
    "generic_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite lors du chargement de l'expérience. Veuillez rafraîchir la page"])}
  },
  "permissions": {
    "voice_unsupported": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite. L'enregistrement oral ne semble pas compatible avec votre ordinateur"])},
    "voice_permission_denied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persmission refusée pour votre microphone"])}
  }
}